"use client";
import React from "react";
import Link from "next/link";
import {
  ButtonWrapper,
  ContactButton,
  LinkButton,
} from "@/src/api/fetchHomeSections/types";

const isContactButton = (btn: ButtonWrapper): btn is ContactButton => {
  return btn.acf_fc_layout === "contact_button";
};

const isLinkButton = (btn: ButtonWrapper): btn is LinkButton => {
  return btn.acf_fc_layout === "link_button";
};

interface ReusableButtonsProps {
  buttons: ButtonWrapper[];
  onContactClick: () => void;
}

const ReusableButtons: React.FC<ReusableButtonsProps> = ({
  buttons,
  onContactClick,
}) => {
  if (!buttons || buttons.length === 0) return null;

  return (
    <div className="mt-4 flex flex-wrap gap-4">
      {buttons.map((btn, index) => {
        if (isContactButton(btn)) {
          return (
            <button
              key={index}
              className="btn-primary"
              onClick={onContactClick}
            >
              {btn.contact_button}
            </button>
          );
        }

        if (isLinkButton(btn)) {
          const { title, url, target } = btn.link_button || {};

          const isExternal =
            typeof url === "string" &&
            (url.startsWith("http") || url.startsWith("//"));

          if (!url) return null;

          return isExternal ? (
            <a
              key={index}
              href={url}
              target={target || "_blank"}
              rel="noopener noreferrer"
            >
              <button className="btn-primary">{title}</button>
            </a>
          ) : (
            <Link key={index} href={url} passHref>
              <button className="btn-primary">{title}</button>
            </Link>
          );
        }

        return null;
      })}
    </div>
  );
};

export default ReusableButtons;
